import { render, staticRenderFns } from "./LocaleSwitcher.vue?vue&type=template&id=148d1b96&scoped=true&"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitcher.vue?vue&type=style&index=0&id=148d1b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d1b96",
  null
  
)

export default component.exports